import React from 'react';
import { getUwinData } from '../../../../services/adminService';
import UwinDataTable from './UwinDataTable';
import UwinVisualInsights from './UwinVisualInsights';
import { cohorts } from "../../../../constant";
import DataPoints from '../DataPoints';
import { exportToCSV } from '../../../../utils/exportUtils';

const calculateTotalsFn = (chartRecords) => {
    let non = 0, mild = 0, mod = 0, sev = 0;
    chartRecords.forEach((r) => {
        cohorts.forEach((c) => {
            non += Number(r[c.non] || 0);
            mild += Number(r[c.mild] || 0);
            mod += Number(r[c.mod] || 0);
            sev += Number(r[c.sev] || 0);
        });
    });
    return { non, mild, mod, sev };
};

const exportCSVFn = (localData, sourceName) => {
    const headers = [
        "ID", "Report Date", "District", "District LGD", "State", "State LGD",
        "Preg Non-Anemic", "Preg Mild", "Preg Moderate", "Preg Severe",
        "Toddlers Non-Anemic", "Toddlers Mild", "Toddlers Moderate", "Toddlers Severe",
        "School Non-Anemic", "School Mild", "School Moderate", "School Severe",
        "Teen Non-Anemic", "Teen Mild", "Teen Moderate", "Teen Severe",
        "WRA Non-Anemic", "WRA Mild", "WRA Moderate", "WRA Severe",
        "Lactating Non-Anemic", "Lactating Mild", "Lactating Moderate", "Lactating Severe",
        "Men Non-Anemic", "Men Mild", "Men Moderate", "Men Severe",
        "Senior Women Non-Anemic", "Senior Women Mild", "Senior Women Moderate", "Senior Women Severe"
    ];

    const fields = [
        "id", "report_date", "district_name", "district_lgd", "state_name", "state_lgd",
        "preg_non_anaemic", "preg_mild", "preg_moderate", "preg_severe",
        "child_6_59m_non_anaemic", "child_6_59m_mild", "child_6_59m_moderate", "child_6_59m_severe",
        "child_5_9y_non_anaemic", "child_5_9y_mild", "child_5_9y_moderate", "child_5_9y_severe",
        "child_10_19y_non_anaemic", "child_10_19y_mild", "child_10_19y_moderate", "child_10_19y_severe",
        "wra_20_49y_non_anaemic", "wra_20_49y_mild", "wra_20_49y_moderate", "wra_20_49y_severe",
        "lactating_non_anaemic", "lactating_mild", "lactating_moderate", "lactating_severe",
        "men_19plus_non_anaemic", "men_19plus_mild", "men_19plus_moderate", "men_19plus_severe",
        "women_49plus_non_anaemic", "women_49plus_mild", "women_49plus_moderate", "women_49plus_severe"
    ];

    exportToCSV(localData, sourceName, headers, fields);
};

const UwinDataPoints = ({ onTotalsCalculated }) => {

    return (
        <DataPoints
            sourceName="U-WIN"
            fetchDataFn={getUwinData}
            onTotalsCalculated={onTotalsCalculated}
            renderVisuals={(chartData, loading, overallTotals) => (
                <UwinVisualInsights chartData={chartData} loading={loading} overallTotals={overallTotals} />
            )}
            renderTable={(records, loading, currentPage, setCurrentPage, totalCount, totalPages, rowsPerPage) => (
                <UwinDataTable
                    records={records} loading={loading}
                    currentPage={currentPage} setCurrentPage={setCurrentPage}
                    totalCount={totalCount} totalPages={totalPages} rowsPerPage={rowsPerPage}
                />
            )}
            exportCSVFn={exportCSVFn}
            calculateTotalsFn={calculateTotalsFn}
        />
    );
};

export default UwinDataPoints;
